import React from 'react';
import Sidebar from './Sidebar';

interface AppLayoutProps {
  children: React.ReactNode;
  currentPath: string;
}

export default function AppLayout({ children, currentPath }: AppLayoutProps) {
  return (
    <div className="flex h-screen bg-background overflow-hidden">
      {/* Skip link */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[100] focus:px-4 focus:py-2 focus:bg-accent focus:text-black focus:font-mono focus:text-xs focus:font-bold focus:uppercase focus:tracking-widest focus:outline-none"
      >
        Zum Hauptinhalt springen
      </a>
      <Sidebar currentPath={currentPath} />
      <main id="main-content" className="flex-1 overflow-y-auto bg-background" role="main">
        {children}
      </main>
    </div>
  );
}